import { render, staticRenderFns } from "./reemplazaEquipo.vue?vue&type=template&id=78f52b1a&"
import script from "./reemplazaEquipo.vue?vue&type=script&lang=ts&"
export * from "./reemplazaEquipo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('78f52b1a', component.options)
    } else {
      api.reload('78f52b1a', component.options)
    }
    module.hot.accept("./reemplazaEquipo.vue?vue&type=template&id=78f52b1a&", function () {
      api.rerender('78f52b1a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/CambiosServicio/reemplazaEquipo.vue"
export default component.exports